<ng-container *ngIf="sessionAcquisitions$ | async as sessionAcquisitions; else loadingState">
  <ng-container *ngIf="sessionAcquisitions.length > 0; else emptyState">
    <!-- Filters -->
    <form [formGroup]="filterFields" class="acquisition-filters form-full-width">
      <mat-checkbox [checked]="checkedStatus?.checked" [indeterminate]="checkedStatus?.indeterminate" (change)="checkAcquisition()"
        [attr.data-id]="'acquisitions-select-all'"></mat-checkbox>
      <span class="filter-field" style="flex: 4">
        <div matTooltip="{{ getFieldTooltip('description') }}"
          matTooltipClass="tooltip-stretch"
          matTooltipPosition="above"
          class="sort-icon-wrapper"
          test-id="file-description-sort"
          (click)="changeSort('description')">
          <fw-sort-icon field="description" [sort]="fileSort"></fw-sort-icon>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'acquisitionList.fileFieldLabels.file' | translate }} {{ 'acquisitionList.fileFieldLabels.description' | translate }}</mat-label>
          <input type="text" matInput formControlName="description" autocomplete="off" [attr.data-id]="'acquisitions-desc-filter'">
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 2">
        <div matTooltip="{{ getFieldTooltip('created') }}"
          matTooltipClass="tooltip-stretch"
          matTooltipPosition="above"
          class="sort-icon-wrapper"
          test-id="file-created-sort"
          (click)="changeSort('created')">
          <fw-sort-icon field="created" [sort]="fileSort"></fw-sort-icon>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'acquisitionList.fileFieldLabels.created' | translate }}</mat-label>
          <input type="text" matInput formControlName="created" autocomplete="off"
            [attr.data-id]="'acquisitions-created-filter'">
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 2">
        <div matTooltip="{{ getFieldTooltip('classification') }}"
          matTooltipPosition="above"
          class="sort-icon-wrapper"
          test-id="file-classification-sort"
          (click)="changeSort('classification')">
          <fw-sort-icon field="classification" [sort]="fileSort"></fw-sort-icon>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'acquisitionList.fileFieldLabels.classification' | translate }}</mat-label>
          <input type="text" matInput formControlName="classification" autocomplete="off" [attr.data-id]="'acquisitions-class-filter'">
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 3">
        <div matTooltip="{{ getFieldTooltip('fileType') }}"
          matTooltipPosition="above"
          class="sort-icon-wrapper"
          test-id="file-type-sort"
          (click)="changeSort('fileType')">
          <fw-sort-icon field="fileType" [sort]="fileSort"></fw-sort-icon>
        </div>
        <mat-form-field appearance="outline" attr.aria-label="{{ 'acquisitionList.fileFieldLabels.file' | translate }} {{ 'acquisitionList.fileFieldLabels.fileType' | translate }}">
          <mat-select formControlName="fileType" class="muted" [attr.data-id]="'acquisitions-type-dropdown'">
            <mat-option value="">{{ 'acquisitionList.fileAllTypes' | translate }}</mat-option>
            <mat-option *ngFor="let fileType of fileTypes" [value]="fileType">{{ fileType }}</mat-option>
          </mat-select>
        </mat-form-field>
      </span>
      <acquisition-sort [formControl]="sortPanel"></acquisition-sort>
    </form>

    <!-- Data -->
    <div cdkDropListGroup>
      <!-- Create New Dropzone -->
      <div *ngIf="!stagedAcquisition"
        cdkDropList
        [cdkDropListData]="{acquisition: null}"
        (cdkDropListDropped)="dropFiles($event)"
        class="new-acquisition-dropzone"
        [ngClass]="{'cdk-visually-hidden': !(state.fileDragging$ | async)}">
        <span class="new-acquisition-placeholder">{{ 'acquisitionList.createAcquisitionDropzone' | translate }}</span>
      </div>
      <!-- New Acquisition Staging Area -->
      <acquisition-files *ngIf="stagedAcquisition"
        [acquisition]="$any(stagedAcquisition)"
        [session]="session"
        (stagedChanged)="stagedAcquisition = null; loadAcquisitions()"
        cdkDropList
        [cdkDropListData]="{acquisition: stagedAcquisition}"
        (cdkDropListDropped)="dropFiles($any($event))">
      </acquisition-files>
      <!-- Acquisitions Saved to the Session -->
      <acquisition-files *ngFor="let acquisition of sortedAcquisitions$ | async; trackBy: getContainerId"
        [acquisition]="acquisition"
        [checked]="isAcquisitionChecked(acquisition._id)"
        [files]="acquisitionFiles.get(acquisition)"
        [session]="session"
        cdkDropList
        [cdkDropListData]="{acquisition: acquisition}"
        (cdkDropListDropped)="dropFiles($event)"
        (checkedChange)="checkAcquisition(acquisition._id, $event)">
      </acquisition-files>
      <!-- Page If > 50 Acquisitions -->
      <mat-paginator *ngIf="pagination.total > pagination.limit"
        [length]="pagination.total"
        [pageSize]="pagination.limit"
        [pageIndex]="pagination.page$.value"
        [hidePageSize]="true"
        [showFirstLastButtons]="true"
        (page)="pagination.page$.next($event.pageIndex)">
      </mat-paginator>
    </div>
  </ng-container>
</ng-container>

<ng-template #loadingState>
  <div *ngIf="!error; else errorState" class="loading-state">
    <mat-progress-bar mode="buffer"></mat-progress-bar>
  </div>
</ng-template>

<ng-template #emptyState>
  <div class="info-message">
    <div class="fab">
      <mat-icon>list</mat-icon>
    </div>
    <p>{{ 'acquisitionList.states.empty' | translate }}</p>
    <button mat-flat-button
      color="primary"
      (click)="sessionService.createAcquisition(session)"
      [attr.data-id]="'acquisitions-new-button'">{{ 'acquisitionList.states.emptyAddNew' | translate }}</button>
  </div>
</ng-template>

<ng-template #errorState>
  <div class="info-message">
    <div class="fab">
      <mat-icon>error_outline</mat-icon>
    </div>
    <p>{{ 'acquisitionList.states.error' | translate }}</p>
    <button mat-flat-button (click)="loadAcquisitions()" color="primary">{{ 'acquisitionList.states.errorReload' | translate }}</button>
  </div>
</ng-template>
